/* ==========================================================================
   Missão do carrinho — <cart-mission> v2
   Progresso por QUANTIDADE de itens, com brinde e modal de resgate.

   O produto do brinde vem SEMPRE do personalizador. Nada aqui conhece um
   produto específico: título, imagem, preço e variante chegam por
   data-attributes vindos do Liquid.

   Animação: usa GSAP quando disponível e cai para a Web Animations API
   quando não. O CDN é um ponto de falha externo — nada pode depender dele.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__cartMissionLoaded) return;
  window.__cartMissionLoaded = true;

  var ROTAS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  /* Fora do elemento: o drawer é re-renderizado por innerHTML e um marco já
     conquistado não pode comemorar de novo a cada re-render. */
  var marcoMaisAlto = -1;
  var primeiraLeitura = true;

  // ------------------------------------------------------------ animação

  var gsapPronto = function () {
    return typeof window.gsap !== 'undefined';
  };

  /* Camada fina sobre GSAP. Sem ele, cai para Web Animations API, que é
     nativa e entrega o mesmo resultado nestas animações curtas. */
  function anima(alvo, quadros, opcoes) {
    if (!alvo) return;
    opcoes = opcoes || {};

    if (gsapPronto()) {
      var de = quadros[0];
      var para = quadros[quadros.length - 1];
      window.gsap.fromTo(alvo, de, Object.assign({}, para, {
        duration: (opcoes.duration || 400) / 1000,
        ease: opcoes.ease || 'power3.out',
        delay: (opcoes.delay || 0) / 1000
      }));
      return;
    }

    if (typeof alvo.animate !== 'function') return;
    try {
      alvo.animate(quadros, {
        duration: opcoes.duration || 400,
        delay: opcoes.delay || 0,
        easing: opcoes.easing || 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: opcoes.fill || 'none'
      });
    } catch (e) { /* animação é enfeite: nunca pode derrubar o carrinho */ }
  }

  function movimentoReduzido() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Carrega GSAP sob demanda, uma vez só, sem bloquear nada. Se falhar,
     seguimos com a Web Animations API e ninguém percebe. */
  function pedirGsap(url) {
    if (!url || gsapPronto() || window.__cmGsapPedido) return;
    window.__cmGsapPedido = true;
    var s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onerror = function () {
      console.warn('[cart-mission] GSAP não carregou; usando animação nativa.');
    };
    document.head.appendChild(s);
  }

  // ------------------------------------------------------------ utilidades

  function moeda(centavos) {
    if (window.Shopify && Shopify.formatMoney && window.cartStrings) {
      return Shopify.formatMoney(centavos, cartStrings.money_format);
    }
    return 'R$ ' + (Number(centavos) / 100).toFixed(2).replace('.', ',');
  }

  function ehRotaDeCarrinho(url) {
    if (!url) return false;
    var s = String(url);
    for (var i = 0; i < ROTAS.length; i++) {
      if (s.indexOf(ROTAS[i]) !== -1) return true;
    }
    return false;
  }

  function escaparHtml(txt) {
    var d = document.createElement('div');
    d.textContent = txt == null ? '' : String(txt);
    return d.innerHTML;
  }

  // ------------------------------------------------------------- confete

  function soltarConfete(hospedeiro, quantidade) {
    if (movimentoReduzido() || !hospedeiro) return;

    var camada = document.createElement('div');
    camada.className = 'cm-confetti';
    hospedeiro.appendChild(camada);

    var cores = ['#f4581f', '#ffd400', '#ffffff', '#14854e', '#4ade80'];
    var caixa = hospedeiro.getBoundingClientRect();
    var total = quantidade || 34;
    var pecas = [];

    for (var i = 0; i < total; i++) {
      var p = document.createElement('i');
      var largura = 5 + Math.random() * 5;
      p.style.background = cores[i % cores.length];
      p.style.width = largura + 'px';
      p.style.height = largura * (1 + Math.random()) + 'px';
      p.style.left = Math.random() * 100 + '%';
      p.style.top = '-14px';
      camada.appendChild(p);
      pecas.push(p);
    }

    var alturaQueda = Math.max(180, caixa.height + 90);

    pecas.forEach(function (p) {
      var desvio = (Math.random() - 0.5) * 190;
      var giro = 360 + Math.random() * 620;
      var dur = 1100 + Math.random() * 900;
      var atraso = Math.random() * 260;

      anima(
        p,
        [
          { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
          {
            transform: 'translate3d(' + desvio + 'px,' + alturaQueda + 'px,0) rotate(' + giro + 'deg)',
            opacity: 0
          }
        ],
        { duration: dur, delay: atraso, easing: 'cubic-bezier(0.3, 0.6, 0.5, 1)', fill: 'forwards' }
      );
    });

    setTimeout(function () {
      if (camada.parentNode) camada.parentNode.removeChild(camada);
    }, 2600);
  }

  // ------------------------------------------------------------- elemento

  class CartMission extends HTMLElement {
    constructor() {
      super();
      this.ocupado = false;
    }

    connectedCallback() {
      this.metas = this.lerMetas();

      this.giftVariantId = Number(this.dataset.giftVariant || 0);
      this.giftTitulo = this.dataset.giftTitle || '';
      this.giftImagem = this.dataset.giftImage || '';
      this.giftAuto = this.dataset.giftAuto === 'true';

      /* Tipos de produto que AVANÇAM a missão.

         Antes a missão somava qualquer item do carrinho menos o
         brinde. Resultado: 3 patches de R$ 30 completavam a meta e
         liberavam o presente sem nenhuma camisa comprada.

         Filtra por product_type e não por tag porque /cart.js NÃO
         devolve as tags do produto — não há como saber ali que algo
         é tipo:camisa. O product_type vem no item e serve, DESDE QUE
         esteja padronizado (ver corrigir-tipo-produto.py).

         Lista vazia mantém o comportamento antigo, de contar tudo. */
      this.tiposQueContam = (this.dataset.tiposQueContam || '')
        .split(',')
        .map(function (t) { return t.trim().toLowerCase(); })
        .filter(Boolean);

      this.msgVazio = this.dataset.msgEmpty || '';
      this.msgProgresso = this.dataset.msgProgress || '';
      this.msgCompleto = this.dataset.msgComplete || '';
      this.msgBloqueado = this.dataset.msgLocked || '';
      this.revelar = this.dataset.reveal === 'true';

      this.elFill = this.querySelector('.cm-fill');
      this.elMessage = this.querySelector('.cm-message-text');
      this.elCounter = this.querySelector('.cm-counter');
      this.elGift = this.querySelector('.cm-gift');
      this.elBox = this.querySelector('.cm-box');

      pedirGsap(this.dataset.gsapUrl);

      if (this.elGift && !this.elGift.dataset.bound) {
        this.elGift.dataset.bound = '1';
        this.elGift.addEventListener('click', this.aoClicarBrinde.bind(this));
      }

      this.montarModal();

      // Estado inicial vem do Liquid, sem requisição.
      this.aplicar(Number(this.dataset.count || 0), Number(this.dataset.giftQty || 0));

      // Confere com o servidor: o Liquid pode vir de cache.
      this.refresh();
    }

    disconnectedCallback() {
      if (this.modal && this.modal.parentNode && !document.body.contains(this)) {
        // o modal vive no <body>; sai junto quando o elemento morre de vez
        this.modal.parentNode.removeChild(this.modal);
        this.modal = null;
      }
    }

    lerMetas() {
      try {
        return (JSON.parse(this.dataset.steps || '[]') || []).filter(function (m) {
          return m && Number(m.qty) > 0;
        });
      } catch (e) {
        return [];
      }
    }

    get metaFinal() {
      return this.metas.length ? Number(this.metas[this.metas.length - 1].qty) : 0;
    }

    /* Os marcos são distribuídos por ÍNDICE (3 marcos = 0%, 50%, 100%), então
       o preenchimento tem de andar por segmento, interpolando entre um marco
       e o próximo. Se usasse contagem/meta, a barra descolaria dos marcos —
       e era isso que fazia o marco do meio parecer que "seguia" a barra.
       Espelha o cálculo do Liquid; mudar um exige mudar o outro. */
    percentual(contagem) {
      var n = this.metas.length;
      if (n === 0) return 0;
      if (n === 1) return contagem >= Number(this.metas[0].qty) ? 100 : 0;

      var passo = 100 / (n - 1);
      var anterior = 0;

      for (var i = 0; i < n; i++) {
        var qty = Number(this.metas[i].qty);
        if (contagem >= qty) {
          anterior = qty;
          if (i === n - 1) return 100;
          continue;
        }
        var faixa = qty - anterior;
        var dentro = faixa > 0 ? (contagem - anterior) / faixa : 0;
        var base = i - 1;
        if (base < 0) { base = 0; dentro = 0; }
        return (base + dentro) * passo;
      }
      return 100;
    }

    // --------------------------------------------------------------- dados

    refresh() {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart.js respondeu ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          self.init(cart);
          return cart;
        })
        .catch(function (err) {
          // Falhar alto no log, mas nunca zerar a barra: manter o último
          // estado é melhor que mostrar progresso que o cliente não perdeu.
          console.warn('[cart-mission] não consegui ler o carrinho:', err);
          return null;
        });
    }

    init(estado) {
      if (typeof estado === 'number') {
        this.aplicar(estado, 0);
        return;
      }
      if (!estado || !estado.items) return;

      var total = 0;
      var qtdBrinde = 0;

      for (var i = 0; i < estado.items.length; i++) {
        var item = estado.items[i];
        if (this.giftVariantId && Number(item.variant_id) === this.giftVariantId) {
          qtdBrinde += item.quantity;
        } else if (this.contaParaMissao(item)) {
          total += item.quantity;
        }
      }

      this.aplicar(total, qtdBrinde);
      this.sincronizarBrinde(total, qtdBrinde);
    }

    /* Um item conta se o tipo dele está na lista. Sem lista, conta tudo. */
    contaParaMissao(item) {
      if (!this.tiposQueContam.length) return true;
      var tipo = (item.product_type || '').trim().toLowerCase();
      return this.tiposQueContam.indexOf(tipo) !== -1;
    }

    // ---------------------------------------------------------- renderizar

    aplicar(contagem, qtdBrinde) {
      this.contagemAtual = contagem;
      this.qtdBrindeAtual = qtdBrinde;

      var meta = this.metaFinal;
      if (!meta) return;

      var completo = contagem >= meta;
      this.classList.toggle('is-complete', completo);

      var pct = Math.max(0, Math.min(100, this.percentual(contagem)));
      if (this.elFill) this.elFill.style.width = pct + '%';

      if (this.elCounter) {
        var mostrado = Math.min(contagem, meta);
        this.elCounter.innerHTML = '<b>' + mostrado + '</b> / ' + meta;
      }

      var indiceAlcancado = -1;
      var self = this;
      this.querySelectorAll('.cm-step').forEach(function (passo, i) {
        var alvo = Number(passo.dataset.qty || 0);
        var alcancado = contagem >= alvo;
        passo.classList.toggle('is-reached', alcancado);
        if (alcancado) indiceAlcancado = i;

        var rotulo = self.querySelector('.cm-label[data-index="' + i + '"]');
        if (rotulo) rotulo.classList.toggle('is-reached', alcancado);
      });

      this.atualizarMensagem(contagem, meta);

      if (!primeiraLeitura && indiceAlcancado > marcoMaisAlto && indiceAlcancado >= 0) {
        this.comemorar(indiceAlcancado, indiceAlcancado === this.metas.length - 1);
      }
      if (indiceAlcancado !== marcoMaisAlto) marcoMaisAlto = indiceAlcancado;
      primeiraLeitura = false;
    }

    /* Placeholders: {faltam} {meta} {itens} {brinde}
       {brinde} vira o título do produto escolhido no personalizador, com a
       miniatura ao lado. Nenhum produto é presumido pelo código. */
    pintarTexto(modelo, faltam, meta) {
      /* A palavra de {itens} vem do personalizador, pelos mesmos data- que o
         Liquid usou. Fixá-la aqui faria "2 camisas" virar "2 itens" no
         primeiro clique de quantidade — o Liquid acerta na primeira pintura e
         este método repinta a cada mudança. */
      var palavra = faltam === 1
        ? (this.dataset.palavraSing || 'item')
        : (this.dataset.palavraPlur || 'itens');
      var nome = this.giftTitulo || '';

      /* Foto + nome juntos, dentro da frase. Precisa espelhar exatamente o
         que o Liquid monta em cm_gift_mark, senão o texto muda de aparência
         na primeira atualização do carrinho. */
      /* No modo surpresa, {brinde} resolve em vazio enquanto a missão não
         fecha — nem nome, nem foto vazam antes da hora. */
      var marcaBrinde = '';
      if (!this.oculto) {
        if (this.giftImagem && this.dataset.thumbInline === 'true') {
          marcaBrinde += '<img class="cm-inline-thumb" src="' + this.giftImagem +
                         '" alt="" loading="lazy" width="24" height="24">';
        }
        if (nome) marcaBrinde += '<strong>' + escaparHtml(nome) + '</strong>';
      }

      return String(modelo)
        .replace(/\{faltam\}/g, faltam)
        .replace(/\{meta\}/g, meta)
        .replace(/\{itens\}/g, palavra)
        .replace(/\{brinde\}/g, marcaBrinde);
    }

    atualizarMensagem(contagem, meta) {
      if (!this.elMessage) return;

      // define antes de pintar: pintarTexto consulta this.oculto
      this.oculto = this.revelar && contagem < meta;
      this.classList.toggle('is-locked', this.oculto);

      var texto;
      if (contagem >= meta) {
        texto = this.pintarTexto(this.msgCompleto, 0, meta);
      } else if (this.oculto) {
        texto = this.pintarTexto(this.msgBloqueado, meta - contagem, meta);
      } else if (contagem <= 0) {
        texto = this.pintarTexto(this.msgVazio, meta, meta);
      } else {
        texto = this.pintarTexto(this.msgProgresso, meta - contagem, meta);
      }

      if (this.elMessage.innerHTML !== texto) {
        this.elMessage.innerHTML = texto;
        if (!movimentoReduzido()) {
          anima(this.elMessage, [
            { opacity: 0.35, transform: 'translateY(4px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 380 });
        }
      }
    }

    comemorar(indice, ehFinal) {
      var passo = this.querySelectorAll('.cm-step')[indice];

      if (passo && !movimentoReduzido()) {
        anima(passo, [
          { transform: 'scale(1)' },
          { transform: 'scale(1.4)' },
          { transform: 'scale(1)' }
        ], { duration: 620 });
      }

      if (ehFinal) {
        if (this.elBox) {
          this.elBox.classList.remove('is-sweeping');
          void this.elBox.offsetWidth;
          this.elBox.classList.add('is-sweeping');
        }

        /* No modo surpresa, este é o instante em que o brinde deixa de ser
           mistério. A foto acabou de entrar no DOM, então anima a partir
           dela — não do texto, que já estava lá. */
        if (this.revelar && !movimentoReduzido()) {
          var self = this;
          requestAnimationFrame(function () {
            var foto = self.querySelector('.cm-inline-thumb');
            if (!foto) return;
            anima(foto, [
              { opacity: 0, transform: 'scale(0.4) rotate(-12deg)' },
              { opacity: 1, transform: 'scale(1) rotate(0deg)' }
            ], { duration: 620 });
            foto.classList.remove('cm-revelou');
            void foto.offsetWidth;
            foto.classList.add('cm-revelou');
          });
        }

        soltarConfete(this.elBox, 30);
      }
    }

    // ---------------------------------------------------------- botão/estado

    /* Não exigir o botão aqui é essencial: no modo automático ele não é
       renderizado, e a guarda antiga matava a sincronização inteira — o
       brinde não entrava sozinho e nunca era removido ao cair da meta. */
    sincronizarBrinde(contagem, qtdBrinde) {
      if (!this.giftVariantId) return;

      var liberado = contagem >= this.metaFinal;

      if (!liberado && qtdBrinde > 0 && !this.ocupado) {
        this.ajustarBrinde(0);
        return;
      }
      if (liberado && qtdBrinde > 1 && !this.ocupado) {
        this.ajustarBrinde(1);
        return;
      }
      if (liberado && qtdBrinde === 0 && this.giftAuto && !this.ocupado) {
        this.adicionarBrinde();
        return;
      }

      this.pintarBotao(liberado, qtdBrinde > 0);
    }

    pintarBotao(liberado, resgatado) {
      if (!this.elGift) return;

      var eraLiberado = this.elGift.classList.contains('is-unlocked');

      this.elGift.disabled = !liberado || resgatado;
      this.elGift.classList.toggle('is-claimed', resgatado);
      this.elGift.classList.toggle('is-unlocked', liberado && !resgatado);

      var rotulo = resgatado
        ? this.elGift.dataset.labelClaimed
        : liberado
          ? this.elGift.dataset.labelDefault
          : this.elGift.dataset.labelLocked;

      var icone = resgatado ? '✓' : liberado ? '🎁' : '🔒';
      var novo = '<span class="cm-gift-icon">' + icone + '</span><span>' + escaparHtml(rotulo || '') + '</span>';
      if (this.elGift.innerHTML !== novo) this.elGift.innerHTML = novo;

      // Momento em que destrava: merece um empurrão visual.
      if (liberado && !resgatado && !eraLiberado && !primeiraLeitura && !movimentoReduzido()) {
        anima(this.elGift, [
          { transform: 'scale(0.94)', opacity: 0.6 },
          { transform: 'scale(1)', opacity: 1 }
        ], { duration: 460 });
      }
    }

    aoClicarBrinde(event) {
      event.preventDefault();
      if (this.giftAuto) return; // no modo automático o botão é só um selo
      if (this.ocupado || !this.giftVariantId) return;
      if (this.contagemAtual < this.metaFinal) return;
      if (this.qtdBrindeAtual > 0) return;
      this.abrirModal();
    }

    // ----------------------------------------------------------------- modal

    montarModal() {
      if (!this.giftVariantId) return;

      // O modal mora no <body> para escapar do overflow e do z-index do drawer.
      var existente = document.getElementById('cm-modal');
      if (existente) existente.parentNode.removeChild(existente);

      var d = this.dataset;
      var img = this.giftImagem
        ? '<img class="cm-modal-img" src="' + this.giftImagem + '" alt="' + escaparHtml(this.giftTitulo) + '" width="132" height="132">'
        : '';

      var modal = document.createElement('div');
      modal.className = 'cm-modal';
      modal.id = 'cm-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'cm-modal-title');

      /* O modal mora no <body>, fora do <cart-mission>, então NÃO herda as
         CSS variables do componente. Sem isto, rgba(var(--cm-accent-rgb),…)
         fica inválido, o gradiente do botão é descartado e ele some no
         fundo branco. Copiar o style resolve na raiz. */
      var vars = this.getAttribute('style');
      if (vars) modal.setAttribute('style', vars);
      modal.innerHTML =
        '<div class="cm-modal-veil" data-cm-close></div>' +
        '<div class="cm-modal-card">' +
          '<button type="button" class="cm-modal-close" data-cm-close aria-label="Fechar">✕</button>' +
          '<h3 class="cm-modal-title" id="cm-modal-title">' + escaparHtml(d.modalTitle || '') + '</h3>' +
          '<p class="cm-modal-sub">' + escaparHtml(d.modalSub || '') + '</p>' +
          '<div class="cm-modal-product">' +
            img +
            '<p class="cm-modal-name">' + escaparHtml(this.giftTitulo) + '</p>' +
            '<span class="cm-modal-price">' + escaparHtml(d.modalPrice || '') + '</span>' +
            '<button type="button" class="cm-modal-confirm">' + escaparHtml(d.modalConfirm || '') + '</button>' +
            '<p class="cm-modal-countdown" aria-live="polite"></p>' +
          '</div>' +
        '</div>';

      document.body.appendChild(modal);
      this.modal = modal;

      var self = this;

      /* O tema fecha o drawer em qualquer clique que não esteja dentro de
         <cart-notification> (handleBodyClick, theme.js). Como o modal mora
         no <body>, todo clique nele — inclusive no botão de fechar — era
         lido como "clique fora" e derrubava o carrinho junto. Segurar a
         propagação aqui mantém o drawer aberto atrás do modal. */
      modal.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      modal.querySelectorAll('[data-cm-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.fecharModal(); });
      });
      modal.querySelector('.cm-modal-confirm')
        .addEventListener('click', function () { self.confirmarResgate(); });

      this.aoTeclar = function (e) {
        if (e.key === 'Escape') self.fecharModal();
      };
    }

    abrirModal() {
      if (!this.modal) return;
      this.modal.classList.add('is-open');
      document.addEventListener('keydown', this.aoTeclar);

      var btn = this.modal.querySelector('.cm-modal-confirm');
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-done', 'is-loading');
        btn.textContent = this.dataset.modalConfirm || '';
        setTimeout(function () { btn.focus(); }, 120);
      }
    }

    fecharModal() {
      if (!this.modal) return;
      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }
      var nota = this.modal.querySelector('.cm-modal-countdown');
      if (nota) {
        nota.classList.remove('is-on');
        nota.textContent = '';
      }
      this.modal.classList.remove('is-open');
      document.removeEventListener('keydown', this.aoTeclar);
      if (this.elGift && !this.elGift.disabled) this.elGift.focus();
    }

    confirmarResgate() {
      if (this.ocupado) return;

      var btn = this.modal ? this.modal.querySelector('.cm-modal-confirm') : null;
      if (btn) btn.classList.add('is-loading');

      var self = this;
      this.adicionarBrinde().then(function (ok) {
        if (!ok) {
          if (btn) btn.classList.remove('is-loading');
          return;
        }
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          btn.disabled = true;
          btn.textContent = self.dataset.modalClaimed || '';
        }
        // Confete dentro do modal: a comemoração acontece onde o olho está.
        var card = self.modal ? self.modal.querySelector('.cm-modal-card') : null;
        soltarConfete(card, 44);

        self.contagemParaFechar(3);
      });
    }

    /* Fecha sozinho, mas avisando. Sumir sem aviso depois de um clique
       importante deixa a pessoa sem saber se deu certo. */
    contagemParaFechar(segundos) {
      var self = this;
      var nota = this.modal ? this.modal.querySelector('.cm-modal-countdown') : null;
      var restante = segundos;

      if (this.temporizador) clearInterval(this.temporizador);

      var modelo = this.dataset.modalClosing || 'Fechando em {s}...';
      var pintar = function () {
        if (nota) nota.textContent = modelo.replace(/\{s\}/g, restante);
      };

      pintar();
      if (nota) nota.classList.add('is-on');

      this.temporizador = setInterval(function () {
        restante -= 1;
        if (restante <= 0) {
          clearInterval(self.temporizador);
          self.temporizador = null;
          self.fecharModal();
          return;
        }
        pintar();
      }, 1000);
    }

    // -------------------------------------------------------- escrita no carrinho

    /* Redesenha a lista de itens do drawer com o HTML que o Liquid acabou de
       gerar. Sem isso o brinde entrava no carrinho mas só aparecia depois de
       recarregar a página. O <cart-mission> fica FORA de #minicart-form e
       sobrevive à troca; o <cart-savings> fica dentro e vem atualizado. */
    redesenharDrawer(html) {
      if (!html) return;
      var alvo = document.getElementById('minicart-form');
      if (!alvo) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('#minicart-form');
        if (novo) alvo.innerHTML = novo.innerHTML;
      } catch (e) {
        console.warn('[cart-mission] não consegui redesenhar o drawer:', e);
      }
    }

    adicionarBrinde() {
      var self = this;
      this.ocupado = true;
      if (this.elGift) this.elGift.classList.add('is-loading');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.giftVariantId, quantity: 1, properties: { _brinde: 'missao' } }],
          sections: ['minicart-form'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add respondeu ' + r.status);
          return r.json();
        })
        .then(function (data) {
          self.redesenharDrawer(data && data.sections && data.sections['minicart-form']);
          self.avisarTema();
          return true;
        })
        .catch(function (err) {
          console.warn('[cart-mission] não consegui adicionar o brinde:', err);
          return false;
        })
        .finally(function () {
          self.ocupado = false;
          if (self.elGift) self.elGift.classList.remove('is-loading');
          self.refresh();
        });
    }

    ajustarBrinde(quantidade) {
      var self = this;
      this.ocupado = true;

      var updates = {};
      updates[this.giftVariantId] = quantidade;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: ['minicart-form'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/update respondeu ' + r.status);
          return r.json();
        })
        .then(function (data) {
          self.redesenharDrawer(data && data.sections && data.sections['minicart-form']);
          self.avisarTema();
          return true;
        })
        .catch(function (err) {
          console.warn('[cart-mission] não consegui ajustar o brinde:', err);
          return false;
        })
        .finally(function () {
          self.ocupado = false;
          self.refresh();
        });
    }

    /* Mexemos no carrinho fora do fluxo do tema; contador, total e barra de
       frete precisam saber. Recarregar a página seria simples e muito pior. */
    avisarTema() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = '(' + cart.item_count + ')';
            } else {
              el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
            }
          });

          var total = document.querySelector('header-total-price');
          if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);

          var frete = document.querySelector('free-ship-progress-bar');
          if (frete && typeof frete.init === 'function') frete.init(cart.items_subtotal_price);

          document.dispatchEvent(
            new CustomEvent('cart:mission-updated', { detail: { cart: cart } })
          );
        })
        .catch(function () { /* só sincronia visual: silêncio é aceitável */ });
    }
  }

  if (!customElements.get('cart-mission')) {
    customElements.define('cart-mission', CartMission);
  }

  // -------------------------------------------------------- <cart-savings>

  /* O badge de economia soma o preço de tabela (compare_at_price) com os
     descontos aplicados. compare_at_price NÃO existe em /cart.js, então a
     conta mora no Liquid e aqui só recarregamos a section recalculada. */
  class CartSavings extends HTMLElement {
    connectedCallback() {
      this.carregando = false;
      this.ultimoTotal = Number(this.dataset.total || 0);
    }

    refresh() {
      if (this.carregando) return;
      this.carregando = true;

      var self = this;
      fetch('/?section_id=cart-savings', { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('section respondeu ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var novo = doc.querySelector('cart-savings');
          if (!novo) return;

          var total = Number(novo.dataset.total || 0);
          var mudou = total !== self.ultimoTotal;

          self.innerHTML = novo.innerHTML;
          self.dataset.total = total;
          self.className = novo.className;
          if (novo.getAttribute('style')) self.setAttribute('style', novo.getAttribute('style'));

          /* A linha do subtotal mora em cart-footer.liquid, fora deste
             elemento, e só se atualiza quando o #minicart-form inteiro é
             re-renderizado. Pelo botão de quantidade isso acontece; por
             /cart/change.js chamado direto, não — e aí o desconto trocava de
             valor com o subtotal parado no número antigo. A conta deixava de
             fechar na tela e o valor a pagar aparecia maior que o real.

             O Liquid manda o subtotal recalculado em data-subtotal; aqui ele
             é escrito no mesmo quadro em que os outros números mudam. Se o
             #minicart-form também se re-renderizar depois, escreve o mesmo
             valor por cima: inofensivo. */
          var subtotal = novo.dataset.subtotal;
          if (subtotal) {
            document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (alvo) {
              if (alvo.textContent.trim() !== subtotal) alvo.textContent = subtotal;
            });
          }

          // Brilho só quando o valor realmente muda, não a cada re-render.
          if (mudou && total > 0) {
            self.classList.remove('is-fresh');
            void self.offsetWidth;
            self.classList.add('is-fresh');
          }
          self.ultimoTotal = total;
        })
        .catch(function (err) {
          // Falha aqui não pode zerar o badge: mostrar economia menor do que
          // a real é pior que manter o último valor bom.
          console.warn('[cart-savings] não consegui atualizar:', err);
        })
        .finally(function () {
          self.carregando = false;
        });
    }
  }

  if (!customElements.get('cart-savings')) {
    customElements.define('cart-savings', CartSavings);
  }

  // ------------------------------------------------- interceptador de fetch

  /* Em vez de editar as ~8 chamadas espalhadas pelo tema, escutamos as rotas
     de carrinho. Vale para add, change, update e clear, venham de onde vierem. */
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] && args[0].url ? args[0].url : args[0];
    var interessa = ehRotaDeCarrinho(url);

    return fetchOriginal.apply(this, args).then(function (resposta) {
      if (interessa && resposta.ok) {
        setTimeout(function () {
          document.querySelectorAll('cart-mission').forEach(function (el) {
            if (!el.ocupado) el.refresh();
          });
          document.querySelectorAll('cart-savings').forEach(function (el) {
            if (typeof el.refresh === 'function') el.refresh();
          });
        }, 90);
      }
      return resposta;
    });
  };
})();
